<button [className]="props.className" (click)="props.click(field, $event)">
  <ng-container *ngIf="!!props.icon">
    <fa-icon [icon]="props.icon" [ngbTooltip]="props.tooltip"></fa-icon>
  </ng-container>

  <ng-container *ngIf="!!props.label">
    {{ props.label }}
  </ng-container>
</button>
